import { useQuery } from '@tanstack/react-query'

import { RecordFactory } from '../models/RecordFactory'

export const useLoadUser = (userId: string | undefined) => {
    return useQuery({
        queryKey: ['client', userId],
        queryFn: async () => {
            if (!userId) {
                return null
            }
            return await RecordFactory.getInstance().loadUser(userId)
        },
    })
}
